import { loadable } from '@shared/core/loadableFromNamedExport';

export const CustomerReviewsLazy = loadable(() => import('./CustomerReviews'), 'CustomerReviews');
